export const ERROR_CODE = 'Error code:'
export const HIDE_DETAILS = 'Hide Details'
export const SERVICE_CODE = 'Service code:'
export const SHOW_DETAILS = 'Show Details'
export const TRY_AGAIN = 'Try Again'
